import { render, staticRenderFns } from "./ContactBox.vue?vue&type=template&id=fa8993a8"
import script from "./ContactBox.vue?vue&type=script&lang=js"
export * from "./ContactBox.vue?vue&type=script&lang=js"
import style0 from "./ContactBox.vue?vue&type=style&index=0&id=fa8993a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports